import axios from "vue-app/utils/axios";
import { DTOCreateSubscriptionResponse, DTOFreemiumLimits, DTOTierPrice } from "vue-app/api/dto";
import { AssasForm } from "vue-app/components/Freemium/Freemium.machine.ts";

const getFreemium = async () => {
  const { data } = await axios.get<DTOFreemiumLimits>("/freemium");
  return data;
};

const getFreemiumPricingTiers = async () => {
  const { data } = await axios.get<DTOTierPrice[]>(`/freemium/pricing/tiers`);
  return data;
};

const postFreemiumUpgrade = async (
  quantity: number,
  max: boolean = true,
  form?: AssasForm,
  hygienizationType?: string
) => {
  const { data } = await axios.post<DTOCreateSubscriptionResponse>("/freemium/upgrade", {
    max: max,
    quantity: quantity,
    hygienization_type: hygienizationType,
    ...form,
  });
  return data;
};

export { getFreemium, postFreemiumUpgrade, getFreemiumPricingTiers };
